import { render } from "./HeroiconsOutlineChat.vue?vue&type=template&id=43c1358f"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChat.vue"]])

export default __exports__